import { render, staticRenderFns } from "./budget-table.vue?vue&type=template&id=4c59987f&"
import script from "./budget-table.vue?vue&type=script&lang=js&"
export * from "./budget-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports